import { createContext, useContext } from 'react';

import { ThemeType } from './types';

// Updated default value to include the correct shape and state type
export const ThemeContext = createContext<{
  toggleTheme: () => void;
  currentTheme: ThemeType;
}>({
  toggleTheme: () => {},
  currentTheme: ThemeType.Dark,
});

export const useTheme = () => useContext(ThemeContext);
